import { TweenLite } from 'gsap';
import debounce from 'lodash/debounce';

const isTablet = () => {
  const tabletBreakpoint = 1239;
  return window.innerWidth < tabletBreakpoint;
};

const shouldShowDownload = () => {
  if (localStorage.getItem('version') !== 'adviser') {
    // Only show download button for advisers as we don't want to capture leads from investors
    if (document.getElementById('guide-download-link')) {
      document.getElementById('guide-download-link').style.display = 'none';
    }
  }
};

const addActiveClass = () => {
  const guideNavLinks = document.getElementsByClassName('guide-nav-item');
  if (guideNavLinks) {
    guideNavLinks.forEach(link => {
      const id = link.href.split('=').pop();
      if (id === window.pageId) {
        link.classList.add('guide-nav-item-active');
      }
    });
  }
};

const setNavState = state => {
  localStorage.setItem('guides-nav-state', state);
};

const getNavState = () => {
  return localStorage.getItem('guides-nav-state');
};

document.addEventListener('DOMContentLoaded', () => {
  const guidePage = document.querySelector('body.single-guides');

  // Check we are on a guide
  if (guidePage) {
    // Used for CSS styles.
    document.body.classList.add('guides-loaded');

    shouldShowDownload();
    if (document.getElementById('guides-childless')) {
      const guideMenu = document.querySelector('.jumpto-sidebar');
      let guideContent = document.querySelector(
        '.single-guides .type-guides > .section > .section-wrapper > .wp-block-deepsea-columns > .wp-block-deepsea-column:last-of-type ',
      );

      // Coronavirus Speific Code Start
      if (document.querySelector('.single-coronavirus-updates') !== null) {
        guideContent = document.querySelector(
          '.single-coronavirus-updates .type-coronavirus-updates > .section > .section-wrapper > .wp-block-deepsea-columns > .wp-block-deepsea-column:last-of-type ',
        );
      }
      // Coronavirus Speific Code End

      if (document.querySelector('.single-whitepapers') !== null) {
        guideContent = document.querySelector(
          '.single-whitepapers > .section > .section-wrapper > .wp-block-deepsea-columns > .wp-block-deepsea-column:last-of-type ',
        );
      }

      const toggle = document.getElementById('guidesNav-toggle');
      const jumptoNavLinks = document.querySelectorAll('a.jumpto-sidebar-link');
      let open = false;
      let count = 0;

      if (toggle) {
        toggle.onclick = () => {
          open = !open;

          toggle.classList.toggle('active');
          document.getElementsByTagName('html')[0].classList.toggle('guide-nav-open');

          if (count > 0) {
            toggle.classList.toggle('closed');
          }

          count += 1;

          if (open) {
            TweenLite.to(guideContent, 0.3, { transform: 'translateX(380px)' });
            TweenLite.to(guideMenu, 0.3, { left: '0px' });
          } else {
            TweenLite.to(guideContent, 0.3, { transform: 'translateX(0px)' });
            TweenLite.to(guideMenu, 0.3, { left: '-380px' });
          }
        };

        Array.from(jumptoNavLinks).forEach(element => {
          element.addEventListener('click', event => {
            event.preventDefault();
            open = !open;

            toggle.classList.toggle('active');
            document.getElementsByTagName('html')[0].classList.toggle('guide-nav-open');

            if (count > 0) {
              toggle.classList.toggle('closed');
            }

            count += 1;

            if (open && window.innerWidth < 1281) {
              TweenLite.to(guideContent, 0.3, { transform: 'translateX(380px)' });
              TweenLite.to(guideMenu, 0.3, { left: '0px' });
            } else if (window.innerWidth < 1281) {
              TweenLite.to(guideContent, 0.3, { transform: 'translateX(0px)' });
              TweenLite.to(guideMenu, 0.3, { left: '-380px' });
            }
          });
        });
      }
    } else {
      addActiveClass();
      const header = document.getElementById('masthead');
      if (header) {
        header.style.display = 'block';
      }
      const guideMenu = document.querySelector('.jumpto-sidebar');
      const hideToggle = document.getElementById('hide-toggle');
      const hideContainer = document.getElementById('hide-container');
      const showToggle = document.getElementById('show-container');
      const mobileShowToggle = document.getElementById('mobile-show-toggle');
      const mobileHideToggle = document.getElementById('mobile-hide-toggle');
      const navLinks = document.getElementById('guide-nav-links');

      // Make sure guide menu exits, avoids errors on pages without.
      if (!guideMenu) {
        return;
      }

      const handleOpenDesktopNav = () => {
        setNavState('open');
        showToggle.style.display = 'none';
        hideContainer.style.display = 'flex';
        navLinks.style.display = 'block';
        document.body.classList.remove('guides-nav-closed');
        document.body.classList.add('guides-nav-open');
        TweenLite.to(guideMenu, 0.3, { minWidth: '372px' }); // Change this value in guides-single.scss if updated.
      };

      const handleCloseDesktopNav = () => {
        setNavState('closed');
        hideContainer.style.display = 'none';
        navLinks.style.display = 'none';
        showToggle.style.display = 'block';
        document.body.classList.remove('guides-nav-open');
        document.body.classList.add('guides-nav-closed');
        TweenLite.to(guideMenu, 0.3, { minWidth: '200px', width: '200px' });
      };

      const handleOpenMobileNav = () => {
        setNavState('open');
        mobileHideToggle.style.display = 'block';
        mobileShowToggle.style.display = 'none';
        guideMenu.style.display = 'block';
        navLinks.style.display = 'block';
        document.body.classList.remove('guides-nav-closed');
        document.body.classList.add('guides-nav-open');
        // Speed up animation on mobile for snappier experience.
        TweenLite.to(guideMenu, 0.1, { minWidth: '268px', width: '268px' });
      };

      const handleCloseMobileNav = () => {
        setNavState('closed');
        mobileHideToggle.style.display = 'none';
        mobileShowToggle.style.display = 'block';
        navLinks.style.display = 'none';
        document.body.classList.remove('guides-nav-open');
        document.body.classList.add('guides-nav-closed');
        // Speed up animation on mobile for snappier experience.
        TweenLite.to(guideMenu, 0.1, { minWidth: '0px', width: '0px' });
      };

      /**
       * Handle whether to show the mobile nav, and if it should be open or not.
       */
      const handleNavState = () => {
        // If no nav state stored, also open it.
        if (!getNavState() || getNavState() === 'open') {
          if (isTablet()) {
            handleOpenMobileNav();
          } else {
            handleOpenDesktopNav();
          }
          // Make sure there is a nav state before closing.
        } else if (getNavState() && getNavState() === 'closed') {
          if (isTablet()) {
            handleCloseMobileNav();
          } else {
            handleCloseDesktopNav();
          }
        }
      };

      handleNavState();

      if (showToggle) {
        showToggle.onclick = () => handleOpenDesktopNav();
      }

      if (hideToggle) {
        hideToggle.onclick = () => handleCloseDesktopNav();
      }

      if (mobileShowToggle) {
        mobileShowToggle.onclick = () => handleOpenMobileNav();
      }

      if (mobileHideToggle) {
        mobileHideToggle.onclick = () => handleCloseMobileNav();
      }

      /**
       * Update the nav state on window resize so the correct menu is displayed.
       */
      window.addEventListener(
        'resize',
        debounce(() => {
          handleNavState();
        }, 100),
      );
    }
  }
});
